import {PencilIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useId, useRef, useState} from 'react'

import {TokenizedQuery} from './TokenizedQuery'
import type {DynamicPickerAnchorProps, IPickerItem} from './types'

export function DynamicPickerAnchor<T extends IPickerItem>(props: DynamicPickerAnchorProps<T>) {
  const [isDialogOpen, setDialogOpen] = useState(Boolean(props.isOpenInitially))
  const openDialogButtonRef = useRef<HTMLAnchorElement>(null)

  const anchorLabelId = useId()

  return (
    <>
      <div className="d-flex flex-items-center gap-2">
        <div id={anchorLabelId} className="overflow-hidden">
          {props.query ? (
            <>
              <span className="sr-only">Active filter: </span>
              <TokenizedQuery query={props.query} />
            </>
          ) : (
            'No filter'
          )}
        </div>
        <IconButton
          ref={openDialogButtonRef}
          onClick={() => setDialogOpen(true)}
          icon={PencilIcon}
          aria-label="Open filter dialog"
          aria-describedby={props['aria-describedby'] ?? anchorLabelId}
        />
        {isDialogOpen &&
          // eslint-disable-next-line react-hooks/refs
          props.renderDialog({onDismiss: () => setDialogOpen(false), returnFocusRef: openDialogButtonRef})}
      </div>
    </>
  )
}
